module.exports = __webpack_public_path__ + "images/kihnu/android-icon-192x192.png";